import axios from "axios";

const makeDynamicData = (data, maxPressure) => {
  const colorConfig = {
    Kvikkleire: "#EB4036",
    Leire: "#EBE25B",
    "Tørrskorpe leire": "#87241F",
    Silt: "#FFCB57",
    Sand: "#4E9937",
    Friksjonsjord: "#5BA1C2",
    Stein: "#787169",
    Morene: "#787169",
    "Harde masser": "#787169",
    Berg: "#292624",
    Drenert: "#6CCF50",
    Udrenert: "#EBE25B",
  };
  let maxDepth = data[0].max_depth;
  if (maxDepth == 0) {
    maxDepth = data.slice(-1)[0].stop;
  }
    
  data.push({ type: "Slutt", start: maxDepth, stop: maxDepth });

  data[0]["draggable"] = false;
  data[0]["max_depth"]=maxDepth
  data[0]["deleteButtonWidth"] = 0;
  data[0]["pressure"] = maxPressure;
  data[0]["fillColor"] = colorConfig[data[0]["type"]];
  data[0]["bulletDisabled"] = false;

  for (var j = 1; j < data.length - 1; j++) {
    data[j]["fillColor"] = colorConfig[data[j]["type"]];
    data[j]["draggable"] = true;
    data[j]["bulletDisabled"] = false;
    data[j]["deleteButtonWidth"] = 25;
    data[j]["pressure"] = maxPressure;
    data[j]["max_depth"] = maxDepth;
    
  }

  data[data.length - 1]["draggable"] = false;
  data[data.length - 1]["hideButtons"] = true;
  data[data.length - 1]["bulletDisabled"] = true;
  data[data.length - 1]["pressure"] = maxPressure;
  data[data.length - 1]["max_depth"] = maxDepth;


  return data;
};

const findMaxPressure = (staticData) => {
  let maxPressure = 1;

  for (var i = 0; i < staticData.length; i++) {
    if (staticData[i]["Trykk"] > maxPressure) {
      maxPressure = staticData[i]["Trykk"];
    }
  }

  return maxPressure;
};

export const fetchBoreholeList = async (project_id,token) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_GEOTOLK_API}/soilclassification/project/${project_id}/boreholes`
      ,{headers: {
        Authorization: `Bearer ${token}`,
      },}
    );
    const { data } = res;
    if (data) {
      Object.keys(data).forEach((key, index) => {
        let selectedFiles = data[key];
        let maxPressure = findMaxPressure(selectedFiles?.STATIC_DATA);
        //   selectedFiles.DYNAMIC_DATA = makeDynamicData(selectedFiles.TLK, maxPressure);
        selectedFiles.DYNAMIC_DATA = makeDynamicData(
          JSON.parse(JSON.stringify(selectedFiles.TLK)),
          maxPressure
        );
        // selectedFiles.CPT = selectedFiles.CPT ? JSON.parse(selectedFiles.CPT) : null;
        // selectedFiles.PRV = selectedFiles.PRV ? JSON.parse(selectedFiles.PRV) : null;


        //   selectedFiles.TLK = selectedFiles.TLK ? JSON.parse(selectedFiles.TLK) : null;
        
      });
    }
    return data;
  } catch (e) {
    throw new Error(e);
  }
};
